var ColumnGroup = function ColumnGroup() {};
ColumnGroup.displayName = 'ColumnGroup';
ColumnGroup.defaultProps = {
  __TYPE: 'ColumnGroup'
};

export { ColumnGroup };
